import { render, staticRenderFns } from "./updateSchema.vue?vue&type=template&id=63d52bc6"
import script from "./updateSchema.vue?vue&type=script&lang=js"
export * from "./updateSchema.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports